import * as React from 'react';
import { Search } from 'semantic-ui-react';
import * as InfoCardApi from '~/Api/InfoCard';
import { useApiResult } from '~/ApiHooks';
import { Tag } from '~/InfoCard/Tag';
var ContentTag = function (_a) {
    var tag = _a.tag;
    return tag !== null ? (<span className='autocomplete-label'>
			<Tag tag={tag}/>
		</span>) : null;
};
var parse = function (data) {
    return data.map(function (item) { return ({
        id: item.result.id,
        tags: item.result.tags,
        title: item.result.title,
        yearmonth: item.result.yearMonth,
    }); });
};
export var Autocomplete = function (_a) {
    var _b, _c;
    var onSelect = _a.onSelect;
    var _d = React.useState(''), text = _d[0], setText = _d[1];
    var results = useApiResult(new InfoCardApi.SearchRequest(text), [text])[0];
    var parsedResult = parse((_c = (_b = results.value) === null || _b === void 0 ? void 0 : _b.items) !== null && _c !== void 0 ? _c : []);
    return (<Search resultRenderer={function (props) {
            var _a, _b, _c, _d, _e, _f, _g;
            var index = props.id;
            var infoCard = parsedResult[index];
            return (<div className='content'>
						<div className='title'>{infoCard.title}</div>
						<div className='description'>
							<ContentTag tag={{
                    date: new Date(infoCard.yearmonth),
                    id: (_b = (_a = infoCard.tags.find(function (tag) { return tag.type === InfoCardApi.TagType.yearMonth; })) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '',
                    title: '',
                    type: InfoCardApi.TagType.yearMonth,
                    value: (_d = (_c = infoCard.tags.find(function (tag) { return tag.type === InfoCardApi.TagType.yearMonth; })) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : '',
                }}/>
							<ContentTag tag={(_e = infoCard.tags.find(function (tag) { return tag.type === InfoCardApi.TagType.brand; })) !== null && _e !== void 0 ? _e : null}/>
							<ContentTag tag={(_f = infoCard.tags.find(function (tag) { return tag.type === InfoCardApi.TagType.source; })) !== null && _f !== void 0 ? _f : null}/>
							<br />
							<ContentTag tag={(_g = infoCard.tags.find(function (tag) { return tag.type === InfoCardApi.TagType.market; })) !== null && _g !== void 0 ? _g : null}/>
						</div>
					</div>);
        }} results={parsedResult} showNoResults={!results.isLoading} value={text} onResultSelect={function (_, data) {
            onSelect(data.result.id);
        }} onSearchChange={function (_, data) {
            var _a;
            setText((_a = data.value) !== null && _a !== void 0 ? _a : '');
        }}/>);
};
Autocomplete.displayName = 'InfoCardAutocomplete';
